import type { ColDef } from '@ag-grid-community/core';
import type { AggregateReportConfig, ReportData } from '../report-viewer/report-viewer.model';

/**
 * Column Definitions for 15-Day Activity by OU Report
 */
export const FIFTEEN_DAY_ACTIVITY_COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'OU Path',
    field: 'ouPath',
  },
  {
    headerName: 'Active Devices',
    field: 'activeDevices',
    flex: 1,
  },
  {
    headerName: 'Avg Days Used Per Device',
    field: 'avgDaysUsed',
    flex: 1,
  },
  {
    headerName: 'Avg Total Minutes Used Per Device',
    field: 'avgMinutesUsed',
    flex: 1,
  },
  {
    headerName: 'Devices Not Used',
    field: 'devicesNotUsed',
    flex: 1,
  },
  {
    headerName: 'Devices with No Policy Sync',
    field: 'devicesNoPolicySync',
    flex: 1,
  },
];

/**
 * Configuration for 15-Day Activity by OU aggregate report
 */
export function createFifteenDayActivityReportConfig(data: unknown[]): ReportData {
  const aggregateConfig: AggregateReportConfig = {
    columns: FIFTEEN_DAY_ACTIVITY_COLUMN_DEFS,
    groupFields: ['ouPath'],
    aggregationField: 'activeDevices',
    autoGroupColumnName: 'OU Path',
    data,
  };

  return {
    type: 'fifteen-day-activity',
    data,
    aggregateConfig,
  };
}
